export enum typeChat {
	GENERAL = 'general',
	ORDER = 'order',
}

export enum actionChat {
	SPEAK = 'speak',
}

export enum MessageType {
	SERVICE = 'service',
	NOTIFY = 'notify',
	MESSAGE = 'message',
	WRITING = 'writing',
}

export enum WsCommands {
	SUBSCRIBE = 'subscribe',
	MESSAGE = 'message',
	UNSUBSCRIBE = 'unsubscribe',
}

export enum MessageCode {
	CLOSE_SERVER = 1006,
	CLOSE = 1000,
}

export enum Direction {
	ASC = 'asc',
	DESC = 'desc',
}

export enum ChatFileState {
	SUCCESS = 'success',
	FAILURE = 'failure',
	PENDING = 'pending',
	LOADING = 'loading',
}

export const chatSettingWithType = {
	[typeChat.GENERAL]: 'general_token',
	[typeChat.ORDER]: 'order_token',
}

export enum ApiChatType {
	IBRO,
	BUSINESS_REGISTRATION,
	ORDER,
}
